import Ionicon from "react-ionicons";
import React, { Component } from "react";

export const Saved=(
    <div className="saveAlert perfectCenter">
    <span>SAVED </span>
    <Ionicon
      icon="ios-checkmark"
      fontSize="40px"
      color="#ffffff"
    />
  </div>
  )